const initialState = {
    isLoading: true,
    news: []
};

export default (state = initialState, action) => {
    switch (action.type) {
    case 'FETCH_NEWS_RT_PROCESS':
        return { 
            ...state,
            isLoading: true
        };
    case 'FETCH_NEWS_RT_SUCCESS':
        return { 
            ...state,
            isLoading: false,
            news: action.data
        };
    case 'FETCH_NEWS_RT_ERROR':
        return { 
            ...state,
            isLoading: true,
            news: null
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/home.reducer.js